const getProductTag = (serverTags) => {
  if (serverTags[0]) {
    return {
      iconKey: serverTags[0].key ?? void 0,
      value: serverTags[0].value
    };
  }
  return void 0;
};
export {
  getProductTag
};
//# sourceMappingURL=get-product-tag.js.map
